<template>
  <div class="login-page">
    <app-navbar />
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-6 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h3 slot="header" class="header text-center">
                  Logging in...
                </h3>
              </card>
            </div>
          </div>
        </div>
        <app-footer />
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) " />
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from 'src/components/Layout/LoginAppNavbar';
import AppFooter from 'src/components/Layout/LoginAppFooter';
import authRepository from '../repositories/authRepository';

export default {
    components: {
        AppNavbar,
        AppFooter
    },
    async mounted() {
        try {
            // Get the authorization code and state from URL
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            const state = urlParams.get('state');
            const error = urlParams.get('error');

            if (error) {
                throw new Error(`OAuth error: ${error} - ${urlParams.get('error_description')}`);
            }

            if (!code) {
                throw new Error('No authorization code received from Microsoft');
            }

            // Verify state matches what we stored
            const storedState = sessionStorage.getItem('oidc_state');

            if (state !== storedState) {
                throw new Error('State mismatch - possible CSRF attack');
            }

            // Get the PKCE code verifier
            const codeVerifier = sessionStorage.getItem('pkce_code_verifier');

            if (!codeVerifier) {
                throw new Error('Code verifier not found - PKCE flow error');
            }

            // Exchange code for tokens (frontend does this per MPD pattern)
            const tokens = await this.exchangeCodeForTokens(code, codeVerifier);

            // Send ID token to backend for validation and session creation
            await authRepository.oidcLogin(tokens.id_token);

            // Clear stored state and verifier
            sessionStorage.removeItem('oidc_state');
            sessionStorage.removeItem('oidc_nonce');
            sessionStorage.removeItem('pkce_code_verifier');

            // Success - redirect to main app
            this.$router.push('/main');
        } catch (error) {
            console.error('OAuth callback error:', error);
            // Redirect to login with error
            this.$router.push('/login');
        }
    },

    methods: {
        async exchangeCodeForTokens(code, codeVerifier) {
            const tenantId = process.env.VUE_APP_AZURE_TENANT_ID;
            const clientId = process.env.VUE_APP_AZURE_CLIENT_ID;
            const redirectUri = process.env.VUE_APP_AZURE_REDIRECT_URI || 'http://localhost:8080/callback';

            const tokenUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`;

            const params = new URLSearchParams();
            params.append('client_id', clientId);
            params.append('code', code);
            params.append('redirect_uri', redirectUri);
            params.append('grant_type', 'authorization_code');
            params.append('code_verifier', codeVerifier);
            params.append('scope', 'openid profile email');

            const response = await fetch(tokenUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: params.toString(),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Token exchange failed: ${JSON.stringify(errorData)}`);
            }

            const data = await response.json();

            if (!data.id_token) {
                throw new Error('No ID token in response');
            }

            return data;
        }
    }
};
</script>
<style>
</style>
